$(function () {
	//期待度の表にツールチップ
	// $("dd.big").hover(function () {
	// 	$(this).append('<span class="tooltip">大きな渦が<br>見えるチャンス！</span>').delay(1000).addClass('t-show');
	// },
	// 	function () {
	// 		$(this).removeClass('t-show');
	// 		$('.tooltip').remove();
	// 	});

	//トップページのアラート画像、クリックで消す
	$('#js-close-btn').on('click', () => {
		$('#js-hidden').css('transition', 'inherit');
		$('#js-hidden').fadeOut(200);
		return false;
	});

});
